module.exports = "/_next/static/fonts/founders-grotesk-web-medium-bf851046616cc2900102fb5b1cdb95fe.woff2";